import { api } from "..";
const endpoint = "/api/exports";

export const getExportList = async (queryParams) => {
  return await api.get(`${endpoint}`, { params: queryParams });
};

export const createExport = async (data) => {
  return await api.post(`${endpoint}`, data);
};

export const updateExport = async (id, data) => {
  return await api.put(`${endpoint}/${id}`, data);
};

export const deleteExport = async (id) => {
  return await api.delete(`${endpoint}/${id}`);
};

export const getExportById = async (id) => {
  return await api.get(`${endpoint}/${id}`);
};

export const downloadCommercialInvoice = (id, withBank = false) =>
  api.get(`${endpoint}/${id}/commercial-invoice`, {
    params: { withBank },
    responseType: "blob",
    headers: { Accept: "*/*" },
  });

export const downloadCommercialInvoicePdf = (id, withBank = false) =>
  api.get(`${endpoint}/${id}/commercial-invoice/pdf`, {
    params: { withBank },
    responseType: "blob",
    headers: { Accept: "*/*" },
  });

export const downloadPackingList = (id) =>
  api.get(`${endpoint}/${id}/packing-list`, {
    responseType: "blob",
    headers: { Accept: "*/*" },
  });

export const downloadPackingListPdf = (id) =>
  api.get(`${endpoint}/${id}/packing-list/pdf`, {
    responseType: "blob",
    headers: { Accept: "*/*" },
  });

export const downloadJorgiFactura = (id) =>
  api.get(`${endpoint}/${id}/jorgi-factura`, {
    responseType: "blob",
    headers: { Accept: "*/*" },
  });

// Bulk "select documents to download" modal: `picks` is a list of
// { documentType: "CommercialInvoice"|"PackingList", format: "xlsx"|"pdf", withBank }
export const downloadExportDocumentsBatch = (id, picks) =>
  api.post(`${endpoint}/${id}/documents/download-batch`, picks, {
    responseType: "blob",
    headers: { Accept: "*/*" },
  });


export const getExportFileList = async (params) => {
  return await api.get(`${endpoint}/files`, { params });
};

export const deleteExportFile = async (id) => {
  return await api.delete(`${endpoint}/files/${id}`);
};

export const downloadExportFile = async (id) => {
  return await api.get(`${endpoint}/files/${id}/`, {
    responseType: 'blob'
  });
};

const exportItemsEndpoint = "/api/exports/items";

export const getExportItemList = async (queryParams) => {
  return await api.get(exportItemsEndpoint, { params: queryParams });
};

export const getExportItemById = async (id) => {
  return await api.get(`${exportItemsEndpoint}/${id}`);
};

export const createExportItem = async (data) => {
  return await api.post(exportItemsEndpoint, data);
};

export const updateExportItem = async (id, data) => {
  return await api.put(`${exportItemsEndpoint}/${id}`, data);
};

export const deleteExportItem = async (id) => {
  return await api.delete(`${exportItemsEndpoint}/${id}`);
};

export const uploadExportFiles = (data, file) => {
  const metadata = { ...data, exportId: data.id };
  const formData = new FormData();
  formData.append("metadata", JSON.stringify(metadata));
  formData.append("file", file, file.name);

  return api.post(`${endpoint}/upload/`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};